export enum TimeType {
  Hour = 'hour',
  Minute = 'minute',
}
